<script setup>
import { ref } from 'vue'
import uniqueId from 'lodash/uniqueId'
import FundingEnvelopeListItem from './FundingEnvelopeListItem.vue'

const accordionId = uniqueId('accordion-')
const { envelopes } = defineProps({
  envelopes: {
    type: Array,
    required: true,
  },
})

const displayedEnvelopeId = ref(null)

function isExpanded(envelope) {
  return displayedEnvelopeId.value === envelope.id
}

function toggleEnvelope(envelope) {
  if (isExpanded(envelope)) {
    displayedEnvelopeId.value = null
  } else {
    displayedEnvelopeId.value = envelope.id
  }
}

let firstActiveEnvelope = null
// Select the closest envelope to the current date
if (envelopes.length > 0 && !!(firstActiveEnvelope = envelopes.find((envelope) => envelope.active))) {
  displayedEnvelopeId.value = firstActiveEnvelope.id
}
</script>

<template>
  <div class="accordion d-block" :id="accordionId">
    <FundingEnvelopeListItem
      v-for="envelope in envelopes"
      :key="envelope.id"
      :accordion-id="accordionId"
      :envelope="envelope"
      :expanded="isExpanded(envelope)"
      @toggle="toggleEnvelope(envelope)"
    />
  </div>
</template>
